<template>
    <v-container class="fill-height" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-card class="card">
                    <v-card-text class="card-body" v-if="selectedNodeValue">

                        <v-text-field class="" label="Node Name" readonly color="#c42111" :value="selectedNode ? selectedNode.node_name : ''" />
                        <v-textarea label="Description" readonly color="#c42111" :value="selectedNode ? selectedNode.node_description : ''" rows="3" />
                        <template v-if="selectedNode && selectedNode.node_line_height">
                            <v-textarea label="Value" color="#c42111" no-resize :rows="selectedNode.node_line_height" 
                                :value="selectedNodeValue.node_value"
                                readonly
                                :prepend-inner-icon="selectedNodeValue.object_id > -1 ? 'mdi-cube' : ''"/>
                        </template>
                        <v-btn class="mt-2" width="100%" color="#c42111" :disabled="selectedNodeValue.object_id == -1" @click="viewCommonObjectDetails(selectedNodeValue.object_id, selectedNodeValue.item_id, selectedNodeValue.node_value)">View Common Object Details</v-btn>

                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="8">
                <v-card class="card">
                    <v-card-text>

                        <v-treeview
                            item-key="node_id" item-text="node_name"
                            :items="[selectedTree]"
                            dense
                            activatable
                            return-object
                            :active.sync="selectedNodes"
                            color="#ffffff"
                            v-if="selectedTree && selectedTree.built"
                        >

                            <template v-slot:label="{ item, open }">
                                <span>{{item.node_name}} 
                                    <v-icon>{{ getTreeNodeObjectIcon(item) }}</v-icon>
                                    <!-- <div class="node-file-icon" v-html="getTreeNodeFileIcon(item)" /> -->
                                </span>
                            </template>

                        </v-treeview>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="showCommonObjectItemDetails" max-width="80%" width="800px" persistent>
            <item-edit :itemClone="itemClone" :itemFields="commonObjectItemFields" :fromSiteBook="true" v-if="showCommonObjectItemDetails" @close="showCommonObjectItemDetails = false"></item-edit>
        </v-dialog>

    </v-container>
</template>

<script>
import ItemEdit from "@/components/CommonObjects/ItemEdit";
export default {
    name: 'IssueSiteBook',
    props: ['sitebook'],
    components: {
        ItemEdit
    },
    data: () => ({
        selectedTree: null,
        selectedNodes: [],
        showCommonObjectItemDetails: false,
        commonObjectItemFields: null,
        itemClone: null
    }),

    computed: {
        selectedNode: function() {
            if(this.selectedNodes.length) {
                return this.selectedNodes[0];
            }
            return null;
        },

        selectedNodeValue: function() {
            if(!this.selectedNode) {
                return null;
            }
            let id = this.selectedNode.node_id;

            for (const v of this.$props.sitebook.values) {
                if(v.node_id == id) {
                    return v;
                }
            }
            return {
                node_value: '',
                item_id: -1,
                node_id: id,
                object_id: -1,
            };
        },

    },

    methods: {
        buildSiteTree: function() {
            //this sets the root level to be "usable" as the root actually displayed
            this.selectedTree.node_id = -1;
            this.selectedTree.node_name = this.$props.sitebook.site.site_location;
            if(this.selectedTree.built) {
                // They just changed the location without changing the tree, so we dont need to rebuild it. 
                return;
            }

            let treeClone = JSON.parse(JSON.stringify(this.selectedTree));

            // Attach a children list to each node
            let nodeList = treeClone.tree_structure;
            nodeList.forEach(n => {
                n.children = [];
            });

            // Recursively search for the parent node
            let getNodeParent = function(node, items) {
                for(let item of items) {
                    if(node.parent_node_id == item.node_id) {
                        return item;
                    }
                    if(item.children.length) {
                        let value = getNodeParent(node, item.children);
                        if(value) {
                            return value;
                        }
                    }
                }
            }

            let done = false;
            let i = 0;
            while(!done) {
                done = true;
                i = 0;
                for(i; i < nodeList.length; i++) {
                    if(nodeList[i].parent_node_id != -1) {
                        done = false;
                        let parentItem = getNodeParent(nodeList[i], nodeList);
                        parentItem.children.push(nodeList[i]);
                        nodeList.splice(i, 1);
                        break;
                    }
                }
            }

            treeClone.children = treeClone.tree_structure;
            this.selectedTree = treeClone;
            this.selectedTree.built = true;
        },

        getTreeNodeObjectIcon: function(treeNode) {
            let treeNodeId = treeNode.node_id;
            for(let nodeValue of this.$props.sitebook.values) {
                if(treeNodeId == nodeValue.node_id && nodeValue.object_id != -1) {
                    return 'mdi-cube';
                }
            }
            return '';
        },

        viewCommonObjectDetails: function(commonObjectId, itemId, itemName) {
            let route = (TELSA.apiHost + "commonobjects/itemsitem");
            TELSA.loading(true);
            return this.$http.post(route, {args: {commonObjectId: commonObjectId, itemId: itemId}}).then(response => {
                let result = response.body;
                this.commonObjectItemFields = result;
                this.itemClone = {item_name: itemName};
                this.showCommonObjectItemDetails = true;
                TELSA.loading(false);
            });
        },

    },

    mounted() {
        if(this.$props.sitebook) {
            this.selectedTree = this.$props.sitebook.tree[0];
            this.selectedTree.built = false;
            this.buildSiteTree();
        }
    },

    watch: {
        sitebook: {
            handler(newVal, oldVal) {
                console.log('sitebook watch: ', newVal);
                if(newVal) {
                    this.selectedTree = this.$props.sitebook.tree[0];
                    this.selectedTree.built = false;
                    this.buildSiteTree();
                }
            },
            deep: true
        }
    },

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        max-height: calc(100vh - 280px);
        height: calc(100vh - 280px);
        border: solid 1px #ffffff !important;
        box-shadow: 2px 2px 5px 1px rgba(0,0,0,0.75);
    }

    /* .card-body {
        overflow-y: auto;
        height: calc(100% - 52px);
    } */

</style>
